/**
 * ReportsHarvestInspectionParentEntityName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    parentEntityName?: ?string;
}

export class ReportsHarvestInspectionParentEntityName extends React.PureComponent<Props> {
    render() {
        const { parentEntityName } = this.props;
        if (!parentEntityName) return null;
        return parentEntityName;
    }
}

const mapStateToProps = createStructuredSelector({
    parentEntityName: makeSelectReportsHarvestInspectionValue(
        'parentEntityName'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionParentEntityName
);
